import axios from 'axios'
import * as CONFIG from '../config/index'
import * as helper from './helper'

export const IDEA_API_URL = `${CONFIG.API_URL}/company`

export const getAll = async () => {
  try {
    let res = await axios.get(IDEA_API_URL + '/search?pageNo=1&pageSize=1000');
    return res.data.data.items;
  } catch (e) {
    console.error(e);
  }
}

export default {
  getAll: getAll
}



// WEBPACK FOOTER //
// ./src/common/company.js